import React from 'react';
import './ServicesDeepTms.scss';

const ServicesDeepTms: React.FC = () => {
  return (
    <>
      <section id="cta" className="cta" style={{ backgroundImage: "linear-gradient(to right, rgb(236, 235, 235) 35%, rgba(42, 42, 95, 0.255) 65%), url('/assets/images/image2.jpg')", backgroundPosition: 'center center', backgroundSize: 'cover', paddingBottom: '130px', paddingTop: '50px' }}>
        <div className="container">
          <div className="text-center">
            <div className="row">
              <div className="col-md-4">
                <img src="/assets/images/logo.png" alt="" height="160" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="cta" className="cta">
        <div className="container">
          <div className="text-center">
            <h3>Deep TMS</h3>
            <p>Elevate Mental Health Treatment With Deep TMS Today!</p>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row mt-3">
            <div className="col-md-12 text-center">
              <p className="fs-3 fw-semibold">Now treating patients with</p>
            </div>
            <div className="col-md-4 mt-3 text-center">
              <p className="fs-4">Major Depressive Disorder</p>
              <img src="/assets/images/MDD.jpg" alt="" height="250" width="100%" />
            </div>
            <div className="col-md-4 mt-3 text-center">
              <p className="fs-4">Obsessive Compulsive Disorder</p>
              <img src="/assets/images/OCD.jpg" alt="" height="250" width="100%" />
            </div>
            <div className="col-md-4 mt-3 text-center">
              <p className="fs-4">Smoking Addition</p>
              <img src="/assets/images/Smoking-Addition.jpg" alt="" height="250" width="100%" />
            </div>
          </div>
        </div>
      </section>

      <section className="gray">
        <div className="container">
          <div className="col-md-12 text-center">
            <h2>How Effective Is Deep TMS?</h2>
          </div>
          <div className="row mt-5">
            <div className="col-lg-12 pt-4 pt-lg-0 order-2 order-lg-1">
              <h2>MDD:</h2>
              <p> Deep TMD has repeated been shown to safely and effectively alleviate depressive symptoms. It's high efficiency level is due to the magnetic field produced by Deep TMS's H-Coil being able to reach wider areas of the brain while also directly stimulating those structures located in is deeper regions. </p>
            </div>
            <div className="col-lg-12 pt-4 pt-lg-0 order-2 order-lg-1">
              <h2>OCD:</h2>
              <p> In the real world clinical practice, 72.6% of OCD patients benefited from a TMS at first response, an the onset of improvement usually occurs within 20 sessions. Extending the treatment course to 29 sessions results in continued reduction of OCD symptoms, raising the prospect of value for extended treatment protocols in non-responders. </p>
            </div>
          </div>
        </div>
      </section>

      <section id="deeptms" className="deeptms">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <img src="/assets/images/BrainsWays-Deep-TMS.jpg" alt="" height="300" width="100%" />
            </div>
            <div className="col-lg-1"></div>
            <div className="col-lg-6 pt-4 pt-lg-0 content">
              <p> Though Deep TMS is proven to be an effective alternative to traditional psychotherapeutic methods, every patient is different. Deep Transcranial Magnetic Stimulation (Deep TMS) is an exciting, innovative treatment that offers effective relief for concussions, PTSD, depression, OCD, anxiety, addiction, and more. Magnetic fields stimulate different brain areas for a quick, painless treatment that requires no downtime for clients.Deep TMS (Transcranial Magnetic Stimulation) uses magnetic waves to reach a deep, targeted area of the brain called the limbic system. Advanced research shows that improperly functioning neurons and nerve cells in the limbic system strongly correlate to depression symptoms.If you are considering this treatment and have any questions concerning what is right for you, please consult your provider. </p>
            </div>
            <div className="col-md-12 mt-5 text-center">
              <h4 className="align-items-center"> Call today to discuss your needs and see if this treatment is a possibility for you. </h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesDeepTms;

